import { render, staticRenderFns } from "./InjectionMold.vue?vue&type=template&id=619d0903&scoped=true"
import script from "./InjectionMold.vue?vue&type=script&lang=js"
export * from "./InjectionMold.vue?vue&type=script&lang=js"
import style0 from "./InjectionMold.vue?vue&type=style&index=0&id=619d0903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d0903",
  null
  
)

export default component.exports